import React from 'react';
import { motion } from 'framer-motion';
import { BadgeLabel, CtaButton } from '../ui';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-grain" data-id="element-28">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-29">
        <img src="https://cdn.magicpatterns.com/uploads/uwdGDeDrMUgBWV2eFo4Fx7/seccion_hero.png" alt="Altar místico bajo la luz de la luna" className="w-full h-full object-cover object-center opacity-40" data-id="element-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-mystic-900/80 via-mystic-900/60 to-mystic-900" data-id="element-31"></div>
        <div className="absolute inset-0 bg-radial-glow opacity-50" data-id="element-32"></div>
      </div>

      {/* Floating Particles (CSS) */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-33">
        {[...Array(20)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-gold rounded-full opacity-20 animate-float" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 5}s`
      }} data-id="element-34" />)}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-36">
          <BadgeLabel className="mb-8" data-id="element-37">
            Manual Digital · Acceso Inmediato · Solo $7 USD
          </BadgeLabel>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative mb-10 mx-auto" data-id="element-38">
          <div className="absolute inset-0 bg-gold/25 blur-[80px] rounded-full" data-id="element-39"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jsVmmC5EfRnDJ68D5KXFco/seccion_hero.png" alt="Antiguo grimorio del ritual ancestral junto a una vela encendida" className="relative z-10 w-48 md:w-64 lg:w-72 h-auto mx-auto drop-shadow-[0_10px_40px_rgba(0,0,0,0.6)] animate-float" data-id="element-40" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6" data-id="element-41">
          <span className="block" data-id="element-42">"El ritual de 3 noches</span>
          <span className="block text-text-secondary" data-id="element-43">
            que los brujos te ocultan
          </span>
          <span className="block gold-gradient-text" data-id="element-44">
            para que sigas pagándoles"
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-text-primary max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-45">
          El secreto ancestral que hace que él o ella regrese —
          <br className="hidden md:block" data-id="element-46" />
          usando solo cosas que ya tienes en casa.
          <br data-id="element-47" />
          <span className="text-gold font-bold mt-2 block" data-id="element-48">
            Sin intermediarios. Sin estafas. Sin más esperas.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="w-full" data-id="element-49">
          <CtaButton subtext={<>
                <span className="flex items-center gap-1" data-id="element-51">
                  <Lock size={14} data-id="element-52" /> Pago 100% seguro
                </span>
                <span className="hidden sm:inline" data-id="element-53">·</span>
                <span className="flex items-center gap-1" data-id="element-54">
                  <Zap size={14} data-id="element-55" /> Descarga instantánea
                </span>
                <span className="hidden sm:inline" data-id="element-56">·</span>
                <span className="flex items-center gap-1" data-id="element-57">
                  <ShieldCheck size={14} data-id="element-58" /> Garantía de 7 días sin preguntas
                </span>
              </>} data-id="element-50">
            → QUIERO RECUPERAR A MI AMOR POR $7
          </CtaButton>
        </motion.div>
      </div>
    </section>;
};